import Axios from '../../config/axios';
import swal from 'sweetalert2';
import { 
  UserAgentApplication
} from 'msal';
import { 
    INICIO_SESION,
    INICIO_CONEXION,
    //ERROR_CONEXION,
    DETENER_CONEXION,
    //CIERRE_SESION,
    //OBTENER_GUID,
    ERROR_GUID,
    VALIDAR_SESION,
    //ERROR_CIERRE_SESSION
} from '../types';

const options = {
  scopes: [process.env.REACT_APP_B2CSCOPES]
};

const msalConfig = {
  auth: {
      clientId: `${process.env.REACT_APP_CLIENTID}`, //This is your client ID
      authority: `${process.env.REACT_APP_AUTHORITY}`, //This is your tenant info
      validateAuthority: false,
      postLogoutRedirectUri: 'https://www.crol.mx',
      navigateToLoginRequestUrl: false
  },
  cache: {
      cacheLocation: "localStorage",
      storeAuthStateInCookie: false
  },
  system: {
    windowHashTimeout: 60000,
    iframeHashTimeout: 6000,
    loadFrameTimeout: 0
  }
};


const myMsal = new UserAgentApplication(msalConfig);
myMsal.handleRedirectCallback( authCallback );

function authCallback(error, response){
}

export function actualizarEstadoLogin( data ) {
  return ( dispatch ) => {
    if( data ){
      dispatch( inicioSesion( data ) );
    } else {
      dispatch( detenerConexion() );
      dispatch( errorGUID('El usuario no se encuentra firmado') );
    }
  }
}

function iniciarSesion() {
  myMsal.loginRedirect(options.scopes);
}

function cerrarSesion() {
  myMsal.logout();
}


/*async function getToken(accessTokenRequest) {
  myMsal.acquireTokenSilent(accessTokenRequest).then(function(accessTokenResponse) {
      // Acquire token silent success
      // Call API with token
      let accessToken = accessTokenResponse.accessToken;
      console.log(accessToken);
      localStorage.setItem("user_data", accessToken);
  }).catch(function (error) {
      //Acquire token silent failure, and send an interactive request
      console.log(error);
      window.alert(error);
      if (error.errorMessage.indexOf("interaction_required") !== -1) {
          myMsal.acquireTokenRedirect(accessTokenRequest);
      }
  });
}*/
  
  /**
   * Action for initiating an interactive sign-in.
   */
  export function login() {
    return (dispatch) => {
      try {
        dispatch(iniciarConexion());
        iniciarSesion();
      } catch (error) {
        console.log( error );
      }
    };
  }
  
  /**
   * Action for initiating a sign-out.
   */
  export function logout() {
    return (dispatch) => {
      dispatch(iniciarConexion());
      cerrarSesion();
    };
  }

  export function validarUsuario ( identity, salir ){
     return async (dispatch) => {      
      
      try {
        let data = { identity, GUID: null };
        let response = null;

        if( salir === '1' && identity ){

          dispatch( detenerConexion() );
          dispatch( errorGUID( 'salir' ) );
          cerrarSesion();

        } else {

          if( identity ){

            try {

              response = await Axios.post( 'auth', data );

              if( response ){
                dispatch( validarSesion( response.data ) );
              }else{
                dispatch( detenerConexion() );
                dispatch( errorGUID('Error al iniciar sesión') );
              }
               /*Axios.post('auth', data).then( (response, error) => {
                if(response){
                  dispatch( validarSesion( response.data ) );
                }else{
                  dispatch( detenerConexion() );
                  dispatch( errorGUID('Error al iniciar sesión') );
                }
              } );*/
              
            } catch (error) {
              let e = {...error};
              console.log(JSON.stringify(e.response));
              swal.fire({
                title: '<strong>Error</strong>',
                html: `<h5>${e.response.data.mensaje}</h5>`,
                icon: 'error',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Ok',
                allowOutsideClick: false,
                allowEscapeKey: false
              }).then((result) => {
                if (result.value) {
                  dispatch( errorGUID( error ) );
                  window.location.href = `${process.env.REACT_APP_BASEURL}/CrolLogin/1`;
                }
              })
            }
          }

        }
        

      } catch (error) {
        let e = {...error};
        console.log(JSON.stringify(e.response));
        swal.fire({
          title: '<strong>Error</strong>',
          html: `<h5>${e.response.data.mensaje}</h5>`,
          icon: 'error',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Ok',
          allowOutsideClick: false,
          allowEscapeKey: false
        }).then((result) => {
          if (result.value) {
            dispatch(errorGUID(error));
          }
        })
      }
    }
  }


const iniciarConexion = () => ( { type: INICIO_CONEXION } );

const detenerConexion = () => ( { type: DETENER_CONEXION } );

//const errorConexion = ( error ) => ( { type: ERROR_CONEXION, payload: error } );

const inicioSesion = ( identity ) => ( { type: INICIO_SESION, payload: identity } );

//const cierreSesion = () => ( { type: CIERRE_SESION } );

const errorGUID = ( error ) => ( { type: ERROR_GUID, payload: error } );

const validarSesion = ( guid ) => ( { type: VALIDAR_SESION, payload: guid } );